import { ref, onMounted } from '@vue/composition-api'

import { LincolnRLSGroupsService } from '@services'

export const useRLSGroup = (RLS = 'TPA', autoFetchRLSGroupItems = true) => {
  const isFetching = ref(false)

  const rlsGroupItems = ref([])

  const fetchRLSGroupItems = async () => {
    isFetching.value = true

    try {
      const { data } = await LincolnRLSGroupsService.list(RLS)
      const { data: results } = data

      isFetching.value = false

      rlsGroupItems.value = results
    } catch (_) {
      isFetching.value = false

      rlsGroupItems.value = []
    }
  }

  const addRLSGroupItem = (newRLSGroupItem) => {
    rlsGroupItems.value.splice(0, 0, newRLSGroupItem)
  }

  const removeRLSGroupItem = (id) => {
    const index = rlsGroupItems.value.findIndex(
      (rlsGroupItem) => rlsGroupItem.id === id
    )

    rlsGroupItems.value.splice(index, 1)
  }

  onMounted(() => {
    if (autoFetchRLSGroupItems) {
        fetchRLSGroupItems();
    }
  })

  return {
    isFetching,

    rlsGroupItems,
    fetchRLSGroupItems,
    addRLSGroupItem,
    removeRLSGroupItem
  }
}
